// The following disable directive for no-restricted-imports is intentional. We need to import it for setup.
// eslint-disable-next-line no-restricted-imports
import GlobalCurrentOwnerContainer from 'crm-legacy-global-containers/GlobalCurrentOwnerContainer';
import CurrentOwnerContainer from '../containers/CurrentOwnerContainer';
export const setupCurrentOwnerContainer = (auth, ownerId) => {
  CurrentOwnerContainer.set(ownerId);
  GlobalCurrentOwnerContainer.setContainer(CurrentOwnerContainer);
};